import BefehlFormAuftrag from '../Generic/BefehlFormAuftrag'
import { useTranslation } from 'react-i18next'

export interface Auftrag29_10FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag29_10Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag29_10FormProps>) {
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="29.10"
      label={t('auftraege.29_10.label')}
      fieldName="auftrag_29_10.enabled"
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.29_10.label')}</span>
    </BefehlFormAuftrag>
  )
}
